import {
  CheckboxSelectionCallbackParams,
  ICellRendererParams,
} from "ag-grid-community";
import { DocumentsComponent } from "./documents.component";

export const cosignDocumentsColumns = (component: DocumentsComponent) => ({
  columnDefinitions: [
    {
      suppressMenu: true,
      headerName: "Activity Date",
      field: "activityDate",
      sortable: true,
      headerClass: "text-xs",
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return params.value;
        }
        return "—";
      },
      headerCheckboxSelection: true,
      checkboxSelection: true,
      showDisabledCheckboxes: false
    },
    {
      suppressMenu: true,
      headerName: "Patient Name",
      field: "patientName",
      sortable: true,
      headerClass: "text-xs",
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return `<span title="${params.value}"> ${params.value} <span>`;
        }
        return "—";
      },
    },
    {
      suppressMenu: true,
      headerName: "Discipline",
      field: "disciplineName",
      sortable: true,
      headerClass: "text-xs",
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return `<span title="${params.value}"> ${params.value} <span>`;
        }
        return "—";
      },
    },
    {
      suppressMenu: true,
      headerName: "Doc Type",
      field: "docType",
      sortable: true,
      headerClass: "text-xs",
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return `<span title="${params.value}"> ${params.value} <span>`;
        }
        return "—";
      },
    },
    {
      suppressMenu: true,
      headerName: "Start Date",
      field: "startDate",
      sortable: true,
      headerClass: "text-xs",
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return `<span title="${params.value}"> ${params.value} <span>`;
        }
        return "—";
      },
    },
    {
      suppressMenu: true,
      headerName: "End Date",
      field: "endDate",
      sortable: true,
      headerClass: "text-xs",
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return `<span title="${params.value}"> ${params.value} <span>`;
        }
        return "—";
      },
    },
    {
      headerName: "Assigned Date",
      suppressMenu: true,
      field: "assignedDate",
      sortable: true,
      headerClass: "text-xs",
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return `<span title="${params.value}"> ${params.value} <span>`;
        }
        return "—";
      },
    },
    {
      suppressMenu: true,
      headerClass: "text-xs",
      field: "selection",
      headerName: "View",
      cellRenderer: (params: any) => {
        ``;
        const link = document.createElement("a");
        link.innerText = "View";
        link.style.cursor = "pointer";
        link.addEventListener("click", (event) => {
          component.navigateToDocumentsPage(params);
        });
        return link;
      },
    },
  ],
});
